module.exports = __webpack_public_path__ + "media/images/standarize-5ab78996195c39f2dcb71dff9d926187.png";